import { Base } from "ui/Scripts/source/framework/base";

export interface IEventMessage {
    id: string;
    text: string;
    modifyDate: number;
    modifyUserCode: string;
    name: string;
    picture: string;
    rowId: string;
    publishIndicator: boolean;
    approveIndicator: boolean;
    closedIndicator: boolean;

    isNew(): boolean;
}

export class EventMessage implements IEventMessage {
    id: string;
    text: string;
    modifyDate: number;
    modifyUserCode: string;
    name: string;
    picture: string;
    rowId: string;
    publishIndicator: boolean;
    approveIndicator: boolean;
    closedIndicator: boolean;

    constructor();
    constructor(obj: IEventMessage);
    constructor(obj?: any) {
        this.publishIndicator = false;
        this.approveIndicator = false;
        this.closedIndicator = false;
        this.id = obj && obj.id || "";
        this.text = obj && obj.text || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.modifyUserCode = obj && obj.modifyUserCode || "";
        this.name = obj && obj.name || "";
        this.picture = obj && obj.picture || "";
        this.rowId = obj && obj.rowId || "";
    }

    isNew(): boolean {
        return Base.isNullOrEmpty(this.rowId);
    }
}